<template>
	<section
		class="leading-[1.4] py-14 xl:py-[96px] px-10 will-change"
		:class="computedClass"
		:data-scroll-section="inner == 'false'"
	>
		<div
			class="will-change flex flex-col items-center justify-center"
			data-scroll
			data-scroll-class="xyz-in"
			xyz="fade down duration-15"
		>
			<img
				class="mb-8 xl:mb-14"
				v-if="blockData.icon_on_top"
				:src="blockData.icon_on_top.url"
				:alt="blockData.icon_on_top.alt"
			/>
			<h2
				:class="[
					'text-4xl xl:text-heading text-lg md:text-xl text-center font-canela font-light xl:w-[55vw] tracking-[1.42pt]',
					blockData.text ? 'mb-8' : '',
				]"
				v-if="blockData.title"
				v-html="blockData.title"
			></h2>
			<div
				class="block-text text-lg md:text-xl text-center font-canela font-light xl:w-[55vw] tracking-[1.42pt]"
				v-if="blockData.text"
				v-html="blockData.text"
			></div>

			<!-- Disclaimer -->
			<div
				class="text-mid-grey text-base my-8"
				v-if="blockData.font_color"
				v-html="blockData.font_color"
			></div>
			<!-- ./Disclaimer -->

			<div class="mt-8" v-if="blockData.name">
				<div
					class="text-2xl text-navy-blue-01 font-canela font-light tracking-[1px] text-center mb-[10px]"
					v-html="blockData.name"
				></div>
				<div
					class="text-base text-navy-blue-02 text-center"
					v-html="blockData.position"
				></div>
			</div>

			<template v-if="blockData.select_cta === 'file'">
				<a
					v-if="blockData.file"
					class="uppercase btn self-center"
					:href="blockData.file.url"
					target="_blank"
					v-html="blockData.file.title"
				></a>
			</template>

			<template v-if="blockData.select_cta === 'tel'">
				<a
					v-if="blockData.tel.url"
					class="uppercase btn self-center"
					:href="'tel:' + blockData.tel.url"
					v-html="blockData.tel.text"
				></a>
			</template>
		</div>
	</section>
</template>

<script>
export default {
	name: "SimpleTextBlock",
	data() {
		return {};
	},
	mounted() {},
	computed: {
		computedClass() {
			let className = "";
			if (this.blockData.background_color === "White") {
				className = ["bg-transparent", "text-navy-blue-02"];
			}
			if (this.blockData.background_color === "Light Blue") {
				className = ["bg-light-blue-03", "text-navy-blue-02"];
			}
			if (this.blockData.background_color === "Dark Blue") {
				className = ["bg-navy-blue-01", "text-white"];
			}
			return className;
		},
	},
	methods: {
		openBlank: function (link) {
			window.open(link, "_blank");
		},
	},
};
</script>
